import { Desktop } from '@phosphor-icons/react';
import { Flex, Input, Select } from 'antd';

/**
 * Toolbar aligned to the right of packing route tabs (station + optional search).
 */
export function PackingTabToolbar({
  stationOptions = [],
  stationId,
  onStationChange,
  search,
  onSearchChange,
  showSearch = false,
}) {
  const selectOptions = stationOptions.map(opt => ({
    value: opt.value,
    label: opt.data?.stationName ?? String(opt.value),
  }));

  return (
    <Flex align="center" gap={8} wrap="nowrap">
      <Select
        value={stationId || undefined}
        onChange={onStationChange}
        options={selectOptions}
        placeholder="Select Station"
        disabled={!selectOptions.length}
        style={{ minWidth: 180 }}
        optionRender={option => (
          <Flex align="center" gap={6}>
            <Desktop size={16} />
            <span>{option.label}</span>
          </Flex>
        )}
        labelRender={({ label }) => (
          <Flex align="center" gap={6}>
            <Desktop size={16} />
            <span>{label}</span>
          </Flex>
        )}
      />
      {showSearch ? (
        <Input.Search
          placeholder="Container, Wave ID"
          value={search ?? ''}
          onChange={e => onSearchChange?.(e.target.value)}
          onSearch={value => onSearchChange?.(value)}
          allowClear
          style={{ width: 220 }}
        />
      ) : null}
    </Flex>
  );
}
